module ProcessEditor {
    "use strict";
    import IModalInstance = angular.ui.bootstrap.IModalServiceInstance;
    export class SaveAsVersionModalController {

        private newMajorMinorVersion: IMajorMinorVersions;
        static $inject = ["majorVersion", "minorVersion", "version", "majorMinorVersions", "$uibModalInstance"];
        constructor(private majorVersion: number, private minorVersion: number, private version: number, private majorMinorVersions: IMajorMinorVersions[], private $modalInstance: IModalInstance) {
            this.newMajorMinorVersion = { majorVersion: majorVersion, minorVersion: minorVersion };
        }
        
        private validateMinorVersion(form: ng.IFormController) {
            if (this.majorVersion != this.newMajorMinorVersion.majorVersion || this.minorVersion != this.newMajorMinorVersion.minorVersion) {
                if (this.majorMinorVersions.some(x=> x.majorVersion == this.newMajorMinorVersion.majorVersion && x.minorVersion == this.newMajorMinorVersion.minorVersion)) {
                    form["minorInput"].$setValidity("numberTaken", false);
                } else {
                    form["minorInput"].$setValidity("numberTaken", true);
                }
            } else {
                form["minorInput"].$setValidity("numberTaken", true);
            }
        }

        public confirm() {
            this.$modalInstance.close(this.newMajorMinorVersion);
        };

        public cancel() {
            this.$modalInstance.dismiss();
        }
    }

    app.controller("SaveAsVersionModalController", SaveAsVersionModalController);
    }